import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MoveIcon, SmileIcon, SparklesIcon } from 'lucide-react';
const carouselImages = ['https://cdn.magicpatterns.com/uploads/jUx71V5f3Dm4ZU57pCft9W/imgblock1.png', 'https://cdn.magicpatterns.com/uploads/fqNsy3wQGXLRXrc39vBavA/imgblock2.png', 'https://cdn.magicpatterns.com/uploads/a65qMccGu8fzkdghK4fD4b/imgblock3.png', 'https://cdn.magicpatterns.com/uploads/46Fc7i5r7zAeAYLk8sQxne/Gemini_Generated_Image_nc4jgknc4jgknc4j.png'];
export function BenefitsSection() {
  const [imgIndex, setImgIndex] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setImgIndex(prev => (prev + 1) % carouselImages.length);
    }, 3000);
    return () => clearInterval(timer);
  }, []);
  const benefits = [{
    title: 'Freedom of Movement',
    description: 'Stop fighting with heavy bases. Stick it to your monitor, your window, or your bed frame. Light exactly where you need it, zero clutter.',
    icon: MoveIcon
  }, {
    title: 'End the Loneliness of Deep Work',
    description: 'Work feels lighter when you have a companion on guard. Its humanoid design adds a touch of wit to your late-night grind.',
    icon: SmileIcon
  }, {
    title: 'Instant Atmosphere',
    description: 'The soft-glow LED tech eliminates harsh glares, creating a cozy-productivity vibe that protects your eyes and boosts your focus.',
    icon: SparklesIcon
  }];
  return <section className="py-12" data-id="element-14">
      <motion.h2 initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="text-3xl font-bold text-center mb-8 text-white" data-id="element-15">
        Why You'll Love It
      </motion.h2>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="w-full max-w-sm mx-auto mb-10 rounded-2xl overflow-hidden border border-white/10 shadow-glow" data-id="element-16">
        <div className="relative w-full aspect-square" data-id="element-17">
          <AnimatePresence mode="wait" data-id="element-18">
            <motion.img key={imgIndex} src={carouselImages[imgIndex]} alt={`LumiMate lamp showcase ${imgIndex + 1}`} initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} exit={{
            opacity: 0
          }} transition={{
            duration: 0.4
          }} className="absolute inset-0 w-full h-full object-cover" data-id="element-19" />
          </AnimatePresence>
        </div>
        <div className="flex justify-center gap-2 py-3 bg-brand-card" data-id="element-20">
          {carouselImages.map((_, i) => <button key={i} onClick={() => setImgIndex(i)} className={`w-2 h-2 rounded-full transition-all duration-300 ${i === imgIndex ? 'bg-brand-orange w-5' : 'bg-white/30 hover:bg-white/50'}`} data-id="element-21" />)}
        </div>
      </motion.div>

      <div className="flex flex-col gap-6" data-id="element-22">
        {benefits.map((benefit, idx) => <motion.div key={idx} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: idx * 0.1
      }} className="bg-brand-card border border-white/5 p-6 rounded-2xl relative overflow-hidden group hover:border-brand-orange/30 transition-colors" data-id="element-23">
            <div className="absolute -right-10 -top-10 w-32 h-32 bg-brand-orange/10 rounded-full blur-3xl group-hover:bg-brand-orange/20 transition-colors" data-id="element-24" />

            <div className="flex items-start gap-5 relative z-10" data-id="element-25">
              <div className="p-3 bg-brand-dark rounded-xl shadow-[0_0_10px_rgba(255,106,0,0.2)] text-brand-orange" data-id="element-26">
                <benefit.icon className="w-6 h-6" data-id="element-27" />
              </div>
              <div data-id="element-28">
                <h3 className="text-xl font-bold text-white mb-2" data-id="element-29">
                  {benefit.title}
                </h3>
                <p className="text-brand-muted leading-relaxed" data-id="element-30">
                  {benefit.description}
                </p>
              </div>
            </div>
          </motion.div>)}
      </div>
    </section>;
}